{
  "controls": [
    {
      "type": "Data",
      "title": "Name",
      "field": "name",
      "required": true,
      "renderOptions": {
        "type": "Standard"
      },
      "children": null
    },
    {
      "type": "Data",
      "title": "Date Of Birth",
      "field": "dateOfBirth",
      "required": true,
      "renderOptions": {
        "type": "Standard"
      },
      "children": null
    },
    {
      "type": "Data",
      "title": "Occupation",
      "field": "occupation",
      "required": true,
      "renderOptions": {
        "type": "Standard"
      },
      "children": null
    },
    {
      "type": "Data",
      "title": "Email",
      "field": "email",
      "required": true,
      "renderOptions": {
        "type": "Standard"
      },
      "children": null
    },
    {
      "type": "Data",
      "title": "Mobile",
      "field": "mobile",
      "required": true,
      "renderOptions": {
        "type": "Standard"
      },
      "children": null
    },
    {
      "type": "Data",
      "title": "Nominator",
      "field": "nominator",
      "required": true,
      "renderOptions": {
        "type": "Standard"
      },
      "children": null
    },
    {
      "type": "Data",
      "title": "Nominator Signature",
      "field": "nominatorSignature",
      "required": true,
      "renderOptions": {
        "type": "Signature"
      },
      "children": null,
      "adornments": [{}, {}],
      "validators": [{}],
      "dynamic": [
        {
          "expr": {}
        }
      ]
    },
    {
      "type": "Data",
      "title": "Seconder",
      "field": "seconder",
      "required": true,
      "renderOptions": {
        "type": "Standard"
      },
      "children": null
    },
    {
      "type": "Data",
      "title": "Seconder Signature",
      "field": "seconderSignature",
      "required": true,
      "renderOptions": {
        "type": "Signature"
      },
      "children": null
    }
  ],
  "config": {},
  "fields": []
}
